<template>
  <div>
    <div class="invoice-module module" :id="moduleData.itemCode" style="padding-bottom: 20px;">
      <div class="module-label">
        {{moduleData.itemName}}
      </div>
      <el-form :class="{ 'cs-form': isCs }" :model="form" :rules="rules" ref="form" label-width="165px" label-position="right" v-if="formConfig.length">
        <el-form-item label-width="0" v-if="invoice.invoiceTitle" class="no-error">
          <div class="invoice-content" :class="{ 'need-address': invoice.invoiceType === 3 }" v-if="invoice.invoiceTitle">
            <div class="invoice-item">
              <span class="label">发票类型：</span>
              <span class="detail">{{ invoice.invoiceType === 3 ? '增值税电子专用发票' : '增值税电子普通发票' }}</span>
            </div>
            <div class="invoice-item" v-if="invoice.invoiceType !== 3">
              <span class="label">抬头类型：</span>
              <span class="detail">{{ invoice.invoiceType === 1 ? '公司' : '个人' }}</span>
            </div>
            <div class="invoice-item">
              <span class="label">{{ invoice.invoiceType === 2 ? '姓名：' : showNewForeign ? '公司名称：' : '发票抬头：' }}</span>
              <span class="detail">
                  {{ invoice.invoiceTitle }}
                  <span class="edit-btn" @click="openInvoice" v-if="!disabledAll">修改</span>
                </span>
            </div>
            <template v-if="invoice.invoiceType !== 2">
              <template v-if="showNewForeign">
                <div class="invoice-item">
                  <span class="label">税号或注册证号：</span>
                  <span class="detail">{{ invoice.taxNo }}</span>
                </div>
                <div class="invoice-item">
                  <span class="label">国家及地区：</span>
                  <span class="detail">{{ invoice.country }}</span>
                </div>
                <div class="invoice-item">
                  <span class="label">城市：</span>
                  <span class="detail">{{ invoice.foreignCity }}</span>
                </div>
                <div class="invoice-item">
                  <span class="label">地址：</span>
                  <span class="detail">{{ invoice.regAddress }}</span>
                </div>
                <div class="invoice-item">
                  <span class="label">邮编：</span>
                  <span class="detail">{{ invoice.postCode }}</span>
                </div>
                <div class="invoice-item">
                  <span class="label">联系人：</span>
                  <span class="detail">{{ invoice.contact }}</span>
                </div>
                <div class="invoice-item">
                  <span class="label">电话：</span>
                  <span class="detail">{{ invoice.regPhone }}</span>
                </div>
              </template>
              <template v-else>
                <div class="invoice-item">
                  <span class="label">税号：</span>
                  <span class="detail">{{ invoice.taxNo }}{{ invoice.isForeign === 1 ? '(境外公司)' : '' }}</span>
                </div>
                <div class="invoice-item">
                  <span class="label">公司地址：</span>
                  <span class="detail">{{ invoice.regAddress }}</span>
                </div>
                <div class="invoice-item">
                  <span class="label">公司电话：</span>
                  <span class="detail">{{ invoice.regPhone }}</span>
                </div>
                <div class="invoice-item">
                  <span class="label">开户银行：</span>
                  <span class="detail">{{ invoice.bankName }}</span>
                </div>
                <div class="invoice-item">
                  <span class="label">银行账号：</span>
                  <span class="detail">{{ invoice.bankNumber }}</span>
                </div>
              </template>
            </template>
            <template v-if="invoice.invoiceType === 2">
              <div class="invoice-item">
                <span class="label">联系电话：</span>
                <span class="detail">{{ invoice.regPhone }}</span>
              </div>
              <div class="invoice-item">
                <span class="label">身份证号：</span>
                <span class="detail">{{ invoice.taxNo }}</span>
              </div>
            </template>
          </div>
        </el-form-item>
        <el-form-item v-else prop="invoiceId" label="公司名称" class="is-required">
          <div class="invoice-btn" @click="openInvoice">+ 从发票簿选择</div>
        </el-form-item>
        <el-form-item label="发票邮寄地址" class="is-required text-item" prop="invoiceAddressId" v-if="invoice.invoiceType === 3 && invoiceAddressData.userPhone">
          {{ invoiceAddressData.province }} {{ invoiceAddressData.city }} {{ invoiceAddressData.town }}
          {{ invoiceAddressData.companyAddress }}{{ invoiceAddressData.companyName ? '，' + invoiceAddressData.companyName + '，' : '，' }}
          {{ invoiceAddressData.userName }}，{{ invoiceAddressData.userPhone }}
        </el-form-item>
        <div class="divider"></div>
        <el-row style="padding-right: 46px;">
          <el-col :span="24" style="display: flex">
            <el-form-item label="付款方联系人">
              <el-button class="copy-btn" @click="copyApplyToPay" :disabled="disabledAll" style="margin-left: 0;">同申请方信息</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="payerName" class="is-required application" :label="configByCode.payerName.attrName">
              <el-input placeholder="" v-model="form.payerName" :maxlength="configByCode.payerName.fillLen" :disabled="disabledAll"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="payerPhone" :label="configByCode.payerPhone.attrName" class="is-required application">
              <el-input placeholder="" v-model="form.payerPhone" :maxlength="configByCode.payerPhone.fillLen" :disabled="disabledAll"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="payerEmail" :rules="configByCode.payerEmail.isMust?rules.payerEmail:rules.payerEmail1" :label="configByCode.payerEmail.attrName" class="application" :class="{'is-required': configByCode.payerEmail.isMust}">
              <el-input placeholder="" v-model="form.payerEmail" :maxlength="configByCode.payerEmail.fillLen" :disabled="disabledAll"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="padding-right: 46px;" v-if="emailRequired">
          <el-col :span="8">
            <el-form-item prop="orderLinkList.0.linkEmail" :rules="rules.linkEmail" label="发票发送邮箱" class="is-required application">
              <el-input v-for="(item, index) in form.orderLinkList" :key="index" placeholder="" v-model="item.linkEmail" maxlength="200" :disabled="disabledAll"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!--              <el-checkbox v-model="isPayEmail" v-if="!disabledAll" @change="copyPayEmail" class="copy-checkbox">同付款方联系人邮箱</el-checkbox>-->
            <el-button class="copy-btn" @click="copyPayEmail" :disabled="disabledAll">使用付款方邮箱</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="module spec-tips" id="invoice-list"
         style="padding-bottom: 30px;"
         v-if="(form.state === 80 || !isOiq && invoiceFileList && invoiceFileList.length)&&notShare&&!isCreate" v-loading="downloadLoading">
      <div class="module-label">发票下载</div>
      <div class="report-content" v-if="invoiceFileList && invoiceFileList.length">
        <div class="report-list-tips">
          {{ orderNo }}共有<span
          style="color:#FF0000;font-weight: bold">{{ invoiceFileList.length }}</span>份发票，请点击文件名下载单个发票
          <template v-if="!invoiceFileList.some(v => v.uploadType === 1)">
            ，您也可以<span class="download-report-btn" @click="downloadReportList">全部下载</span>
          </template>
        </div>
        <div class="report-list">
          <div class="report-item" v-for="(item, index) in invoiceFileList" :key="index">
            <span class="icon"></span>
            <span class="file" @click="downloadFile(item)" v-if="item.uploadType === 2">{{ item.fileName }}</span>
            <a class="file" :href="item.fileUrl" target="_blank" v-else>{{orderNo}}发票{{index+1}}</a>
          </div>
        </div>
      </div>
      <div class="report-content" v-if="!invoiceFileList || !invoiceFileList.length">
        您的发票正在开具中，请耐心等待。
      </div>
    </div>
    <template v-if="!disabledAll">
      <choose-invoice v-model="invoiceDialog" :data.sync="invoice" :apis="apis" v-if="invoiceListShow" :env="env"
                      :isCs="isCs" @addInvoice="toggleInvoice" :userId="formInfo.orderBase.userId"></choose-invoice>
      <template v-else>
        <CreateInvoiceCs v-if="isCs" v-model="invoiceDialog" :data.sync="invoice" :apis="apis" :env="env" :isCs="isCs"
                         :isLogin="isLogin" @showList="toggleInvoice" :hasUser="hasUser && !isCreate" :isAdd="isAdd"></CreateInvoiceCs>
        <CreateInvoice v-else v-model="invoiceDialog" :data.sync="invoice" :apis="apis" :env="env" :isCs="isCs"
                       :isLogin="isLogin"></CreateInvoice>
      </template>
      <choose-address v-model="addressDialog" :currentData.sync="currentData" @updateData="updateAddressData"
                      @delAddress="delAddress" v-if="addressListShow" :apis="apis" @addAddress="toggleAddress" :userId="formInfo.orderBase.userId" :isCs="isCs"></choose-address>
      <CreateAddress :isAdd="isAdd" v-model="addressDialog" :data.sync="currentData" :apis="apis" @updateData="updateAddressData" v-else @showList="toggleAddress" :isCs="isCs" :hasUser="hasUser && !isCreate">
      </CreateAddress>
    </template>
  </div>
</template>

<script>
import {applyMixins} from "src/components/application/components/mixin";
import md5 from "crypto-md5";
import Cookies from "js-cookie";
import {emailReg, tokenKey} from "utils";
import axios from "axios";
import CreateInvoice from "src/components/apply/CreateInvoice.vue";
import ChooseInvoice from "../../invoice/index.vue";
import CreateInvoiceCs from "src/components/apply/CreateInvoiceCs.vue";
import CreateAddress from "src/components/apply/CreateAddress.vue";
import ChooseAddress from "src/components/apply/ChooseAddress.vue";
export default {
  name: "PayInfo",
  components: {
    CreateInvoice,
    ChooseInvoice,
    CreateInvoiceCs,
    CreateAddress,
    ChooseAddress
  },
  mixins: [applyMixins],
  data() {
    return {
      downloadLoading: false,
      invoiceDialog: false,
      invoiceAddressData: {},
      form: {
        invoiceId: '',
        payerName: '',
        payerPhone: '',
        payerEmail: '',
        orderLinkList: []
      },
      invoice: {},
      configByCode: {},
      invoiceListShow: false,
      isAdd: false
    }
  },
  computed: {
    showNewForeign() {
      return this.invoice && this.invoice.isForeign === 1 && !(this.disabledAll && this.invoice.detailNo)
    },
    rules() {
      return {
        invoiceId: [this.required],
        payerName: [this.required],
        payerPhone: [this.required, this.phoneRule],
        payerEmail: [this.required, { pattern: emailReg, message: '请输入正确的邮箱' }],
        payerEmail1: [{ pattern: emailReg, message: '请输入正确的邮箱' }],
        linkEmail: [this.required, this.emailRule]
      }
    }
  },
  watch: {
    formConfig: {
      handler(val) {
        if (!val.length) return
        const configObj = val.find(v => v.areaCode === 'orderInvoice') || {}
        const configArr = configObj.attrs || []
        this.configByCode = this.getFormConfigByCode(configArr)
      },
      immediate: true
    },
    formInfo: {
      handler(val) {
        if (val) {
          if (this.moduleData.sourceFormatJson) {
            this.form = this.formatByJson(val, this.moduleData.sourceFormatJson)
          } else {
            this.form = JSON.parse(JSON.stringify(val))
          }
          if (!this.form.orderLinkList || !this.form.orderLinkList.length) {
            this.form.orderLinkList = [{ linkEmail: '' }]
          }
          this.invoice = this.form.invoice
          if (this.form.addressList && this.form.addressList[0]) this.invoiceAddressData = this.form.addressList[0].userAddressDTO
        }
      },
      immediate: true
    },
    invoice: {
      handler(val) {
        this.$emit('update:invoiceData', val)
      },
      immediate: true
    }
  },
  methods: {
    toggleInvoice() {
      this.invoiceListShow = !this.invoiceListShow
      this.isAdd = !this.invoiceListShow
      this.$nextTick(() => {
        this.invoiceDialog = true
      })
    },
    // 单个下载发票
    downloadFile(data) {
      this.downloadLoading = true
      this.apis.getDownUrl({fileId: data.fileId}).then(res => {
        window.open(res.data.fileUrl)
        this.downloadLoading = false
      }).catch(e => {
        this.downloadLoading = false
      })
    },
    // 批量下载发票
    generateTimeReqestNumber() {
      var date = new Date();
      return date.getFullYear().toString() + this.pad2(date.getMonth() + 1) + this.pad2(date.getDate()) + this.pad2(date.getHours()) + this.pad2(date.getMinutes()) + this.pad2(date.getSeconds());
    },
    pad2(n) { return n < 10 ? '0' + n : n },
    downloadReportList() {
      this.downloadLoading = true
      const that = this
      const files = this.invoiceFileListData.filter(v => v.fileId)
      const zipName = `sgsonline fapiao ${this.orderNo}_${this.generateTimeReqestNumber()}`
      const data = { files, zipName }
      const pid = "pid.mall";
      const pcode = "Z0zCnRE3IaY9Kzem";
      const pmd5 = md5((pid + pcode).toUpperCase(), "hex");
      const param = JSON.stringify(data) + pmd5.toUpperCase();
      const timestamp = new Date().valueOf();
      const sign = md5(param + timestamp, "hex");
      let accessToken = Cookies.get(tokenKey);
      let appId = "99999999";
      this.downloadPdf("/ticCenter/business/api.v0.platform/fileUpload/zipByOss", data, pid, sign, timestamp, appId, accessToken, that, 'downloadLoading', `${zipName}.zip`)
    },
    downloadPdf(url, data, pid, sign, timestamp, appId, accessToken, that, loadingKey, defaultName) {
      let headers = {
        pid,
        sign,
        timestamp,
        appId,
        accessToken
      }
      if(process.env.version) {
        headers.version = 'gray'
      }
      axios({
        data,
        url: this.apiUrl + url,
        method: "post",
        responseType: "blob",
        headers
      }).then(res => {
        that[loadingKey] = false
        let data = res.data;
        let fileReader = new FileReader();
        fileReader.onload = e => {
          try {
            let jsonData = JSON.parse(e.target.result);  // 说明是普通对象数据，后台转换失败
            if (res.resultCode === "9978") {
              redirect()
              return
            }
            this.$message.error(jsonData.resultMsg || '网络异常')
          } catch (err) {   // 解析成对象失败，说明是正常的文件流
            if (res && res.data && res.data.size) {
              var blob = new Blob([res.data], {
                type: "application/actet-stream;charset=utf-8"
              });
              let filename = "";
              var contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
              if (contentDisposition) {
                var patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
                var result = patt.exec(contentDisposition);
                filename = decodeURIComponent(result[1]);
              }
              // IE下载
              if (window.navigator.msSaveOrOpenBlob) {
                var blobObject = new Blob([res.data], {
                  type: "application/actet-stream;charset=utf-8"
                });
                window.navigator.msSaveBlob(
                  blobObject,
                  filename || defaultName || "报价单.pdf"
                );
              } else {
                var downloadElement = document.createElement("a");
                var href = window.URL.createObjectURL(blob); //创建下载的链接
                downloadElement.style.display = "none";
                downloadElement.href = href;
                if (filename) {
                  downloadElement.download = decodeURI(filename).replace(
                    /\+/g,
                    " "
                  );
                } else {
                  downloadElement.download = defaultName || "报价单.pdf"; //下载后文件名
                }
                document.body.appendChild(downloadElement);
                downloadElement.click(); //点击下载
                setTimeout(() => {
                  document.body.removeChild(downloadElement); //下载完成移除元素
                  window.URL.revokeObjectURL(href); //释放掉blob对象
                }, 1000);
              }
            } else {
            }
          }
        }
        fileReader.readAsText(data)
      }).catch(e => {
        that[loadingKey] = false
      });
    },
    openInvoice() {
      if (this.disabledAll) return
      this.isAdd = false
      this.invoice = Object.assign({}, this.invoice)
      this.invoiceDialog = true
      this.invoiceListShow = this.hasUser && (!this.isCs || this.invoice.invoiceId || !this.invoice.invoiceTitle)
    },
    copyApplyToPay() {
      const data = this.$parent.getApplyData()
      this.form.payerName = data.linkPerson
      this.form.payerPhone = data.linkPhone
      this.form.payerEmail = data.linkEmail
    },
    copyPayEmail() {
      const data = this.$parent.getApplyData()
      this.form.orderLinkList[0].linkEmail = data.linkEmail
    },
    getValidate() {
      let data = this.form
      data.invoiceId = this.invoice.invoiceId
      data.invoice = this.invoice
      data.invoiceType = this.invoice.invoiceType
      if (this.moduleData.getFormatJson) {
        data = this.formatByJson(data, this.moduleData.getFormatJson)
      }
      this.$emit('input', JSON.parse(JSON.stringify(data)))
      return new Promise(resolve => this.$refs.form.validate(resolve))
    },
  }
}
</script>

<style scoped>

</style>